import { Ref } from "react";

import { StoreSearchMapComponent } from "./storeSearchMap.component";

type StoreSearchMapContainerProps = {
    ref?: Ref<HTMLDivElement>;
};

const StoreSearchMapContainer = ({ ref }: StoreSearchMapContainerProps) => {
    return <StoreSearchMapComponent ref={ref} />;
};

export { StoreSearchMapContainer };
